import { SVGProps } from 'react';

const SvgPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6 16V5C6 4.73478 6.10536 4.48043 6.29289 4.29289C6.48043 4.10536 6.73478 4 7 4H19L26 11V16"
      stroke="#2196F3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19 4V11H26" stroke="#2196F3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6 25H8C8.53043 25 9.03914 24.7893 9.41421 24.4142C9.78929 24.0391 10 23.5304 10 23C10 22.4696 9.78929 21.9609 9.41421 21.5858C9.03914 21.2107 8.53043 21 8 21H6V27"
      stroke="#2196F3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M27 21H23.5V27" stroke="#2196F3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M26.5 24.5H23.5" stroke="#2196F3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M16 27C16.7956 27 17.5587 26.6839 18.1213 26.1213C18.6839 25.5587 19 24.7956 19 24C19 23.2044 18.6839 22.4413 18.1213 21.8787C17.5587 21.3161 16.7956 21 16 21H14.25V27H16Z"
      stroke="#2196F3"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgPdf;
